<template>
  <section id="weapons" class="weapons">
    <div class="container">
      <SectionTitle :title="t('weapons.title')" :subtitle="t('weapons.subtitle')" />
      <div class="weapons-grid">
        <div
          v-for="(weapon, index) in weapons"
          :key="weapon.title"
          class="weapon-card"
          :style="{ transitionDelay: `${index * 100}ms` }"
          :class="{ visible: visible }"
          ref="cardsRef"
        >
          <div class="weapon-icon">
            <IconSvg :name="weaponIcons[index]" class="wicon" />
          </div>
          <h3>{{ weapon.title }}</h3>
          <p>{{ weapon.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import SectionTitle from './SectionTitle.vue'
import IconSvg from './IconSvg.vue'

const { t, tm } = useI18n()
const weapons = computed(() => tm('weapons.items'))
const weaponIcons = ['assault', 'sniper', 'smg', 'shotgun']

const cardsRef = ref([])
const visible = ref(false)

onMounted(() => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        visible.value = true
        observer.unobserve(entry.target)
      }
    })
  }, { threshold: 0.2 })
  cardsRef.value.forEach((card) => {
    if (card) observer.observe(card)
  })
})
</script>

<style scoped>
.weapons {
  padding: 6rem 0;
  background: #fff;
}
.weapons-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
}
.weapon-card {
  background: #fff8f3;
  border-radius: 20px;
  padding: 2rem;
  text-align: center;
  border: 1px solid rgba(0,0,0,0.04);
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.5s ease;
}
.weapon-card.visible {
  opacity: 1;
  transform: translateY(0);
}
.weapon-card:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow: 0 16px 40px rgba(0,0,0,0.06);
}
.weapon-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.25rem;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(0,0,0,0.06);
  color: var(--text-dark);
}
.wicon {
  width: 40px;
  height: 40px;
}
.weapon-card h3 {
  font-size: 1.2rem;
  color: var(--text-dark);
  margin-bottom: 0.5rem;
}
.weapon-card p {
  color: #6b5f5a;
  font-size: 0.9rem;
  line-height: 1.6;
}
@media (max-width: 900px) {
  .weapons-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .weapons-grid {
    grid-template-columns: 1fr;
  }
}
</style>
